export default {
  vs: {
    id: 'models_comparison_vs',
    defaultMessage: 'Vs',
  },
}
